import palette from '@lib/core/src/theme/palette';
import { Stack, Typography } from '@mui/material';

export const NoActiveTemplates = () => (
  <Stack
    sx={{
      alignItems: 'center',
      justifyContent: 'center',
      height: '283px',
      gap: '16px',
      backgroundColor: palette.white
    }}
  >
    <Typography
      sx={{
        color: palette.black,
        fontSize: '16px',
        fontWeight: 500,
        textAlign: 'center'
      }}
    >
      No Active Templates
    </Typography>
    <Typography
      sx={{
        color: palette.grey[500],
        fontSize: '13px',
        fontWeight: 500,
        textAlign: 'center',
        maxWidth: '60%'
      }}
    >
      You don’t have any active templates at the moment. Get started by adding a new one.
    </Typography>
  </Stack>
);
